import InitHeroAnimations from "./hero";
import InitScrollAnimations from "./scroll";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function InitAnimations() {
	InitHeroAnimations();

	gsap.registerPlugin(ScrollTrigger);

	InitScrollAnimations(gsap, ScrollTrigger);
}
